export const PROJECTS = '/';
export const PROJECT_LANGUAGES = '/project/:project/';
export const PROJECT_TRANSLATE = '/project/:project/:language';
export const ADMIN_APPROVE = '/admin';
export const ADMIN_DOWNLOAD = '/admin/download';
export const ADMIN_UPLOAD = '/admin/upload';
export const ADMIN_SEED = '/admin/seed';